import { images } from '../../constants';
export const data = [
  {
    name: 'Html',
    description:
      'HTML (HyperText Markup Language) is the code that is used to structure a web page and its content',
    image: images.html,
    percent: '24%',
  },
  {
    name: 'Css',
    description:
      'Learn in-demand tech skills - at the speed you want. Text-based courses with embedded coding environments help you learn without the fluff. Learn in your browser. In-browser environments. Learn at your own pace. No set-up required. Interactive exercises.',
    image: images.css,
    percent: '40%',
  },
  {
    name: 'Javascript',
    description:
      "JavaScript (often shortened to JS) is a lightweight, interpreted, object-oriented language with first-class functions, and is best known as the scripting language for Web pages, but it's used in many non-browser environments as well.",

    image: images.javascript,
    percent: '55%',
  },
  {
    name: 'React',
    description:
      'React makes it painless to create interactive UIs. Design simple  views for each state in your application, and React will efficiently  update and render just the right components when your data changes.',

    image: images.react,
    percent: '80%',
  },
];
